import { StreamArbitrary } from './_internals/StreamArbitrary.js';
function infiniteStream(arb) {
    return new StreamArbitrary(arb);
}
export { infiniteStream };
